import { render, staticRenderFns } from "./TableChartTwo.vue?vue&type=template&id=1b42fa12&"
import script from "./TableChartTwo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TableChartTwo.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports